<template>
  <voucher-tab-item
    :key="voucherType"
    queryName="pointsVoucherHistory"
    :table-headers="headers"
    :table-title="title"
    :query="query"
    :voucherType="voucherType"
    :dateName="dateName"
    :transformFunction="transformFunction"
    :filters="filters"
  />
</template>

<script>
import VoucherTabItem from './VoucherTabItem.vue'
import { QUERY_GET_VOUCHERS_HISTORY } from '../../../graphql'

export default {
  name: 'VoucherType',
  components: {
    VoucherTabItem,
  },
  props: {
    voucherType: {
      type: String,
      required: true,
      validator: (value) => ['activated', 'consumed', 'expired'].indexOf(value) !== -1,
    },
    dateName: {
      type: String,
      required: true,
      validator: (value) => ['activated_at', 'consumed_at', 'expired_at'].indexOf(value) !== -1,
    },
    csvFileName: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      default: '',
    },
    filters: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    headers() {
      const consumed = [
        {
          text: 'Desconto/Produto',
          value: 'product_description',
          width: '15%',
          isActive: true,
          isDefault: true,
        },
        {
          text: 'Utilização',
          value: 'date',
          width: '15%',
          isActive: true,
          isDefault: true,
        },
      ]

      const actived = [
        {
          text: 'Desconto/Produto',
          value: 'product_description',
          width: '15%',
          isActive: true,
          isDefault: true,
        },
        {
          text: 'Ativação',
          value: 'date',
          width: '15%',
          isActive: true,
          isDefault: true,
        },
      ]

      const expired = [
        {
          text: 'Desconto/Produto',
          value: 'product_description',
          width: '15%',
          isActive: true,
          isDefault: true,
        },
        {
          text: 'Expiração',
          value: 'date',
          width: '15%',
          isActive: true,
          isDefault: true,
        },
      ]

      const defaultHeader = [
        {
          text: 'CPF/CNPJ',
          value: 'consumer_document_no',
          width: '15%',
          sortable: true,
        },
        {
          text: 'Consumidor',
          value: 'consumer_name',
          width: '20%',
          isActive: true,
          isDefault: true,
        },
        {
          text: 'Loja',
          value: 'unit.name',
          width: '25%',
          isActive: true,
          isDefault: true,
        },
        {
          text: 'Pontos gastos',
          value: 'points',
          width: '12%',
          isActive: true,
          isDefault: true,
        },
      ]

      let headers = []

      switch (this.voucherType) {
        case 'consumed':
          headers = defaultHeader.concat(consumed)
          break
        case 'activated':
          headers = defaultHeader.concat(actived)
          break
        case 'expired':
          headers = defaultHeader.concat(expired)
          break
        default:
          headers = defaultHeader
      }
      return headers
    },
    query() {
      return QUERY_GET_VOUCHERS_HISTORY
    },
    transformFunction() {
      return (item) => {
        const transformedItem = { ...item }
        transformedItem[this.dateName] = item.date
        return transformedItem
      }
    },
  },
}
</script>
